
import React, { useEffect, useState } from 'react';
import './HelpAndSupport.css'
import { useSelector } from 'react-redux';
import { getAllTIcketList, getMessageApi, ticketStatusApi } from '../../api';
import CommonTicket from '../../common/ticket/CommonTicket';
import { toast } from 'react-toastify';



const OpenTicket = () => {

  const token = useSelector((state) => state?.user?.user?.token); 
 
  
  const [openTicketData,setOpenTicketData]=useState([])
  const [loading,setLoading]=useState(false)
  // const [searchQuery, setSearchQuery] = useState("")
  const [myTimout,setMyTimeOut]=useState();
  const [change, setChange] = useState(false);
  const [currentPage,setCurrentPage]=useState(1);
  const [totalPages,setTotalPages]=useState(1);



  // const handleSearchChange = (newQuery) => {
  //   setSearchQuery(newQuery);
  // };
  const handleTicketClose = () => {
    setChange(!change); 
  };

  const handleAllOpenChat=async()=>{
    try {
      let status="Open";
      // setLoading(true)
      const response = await getAllTIcketList({
        token,
        // searchQuery,
        status ,
        currentPage,
        limit:10
      });
      // setAllTicketData(response?.tickets|| []);
      setOpenTicketData((prevTickets) => [...prevTickets, ...response?.tickets]);

      setCurrentPage(response?.currentPage)
      setTotalPages(response?.totalPages)
      setLoading(false);
    } catch (error) {
      setLoading(false)
      console.log("error", error);
    }
  }


  

  useEffect(()=>{
    handleAllOpenChat(currentPage)
  },[currentPage,change])



  // useEffect(() => {
  //   if(searchQuery.trim()!=""){
  //     clearTimeout(myTimout);
  //     setMyTimeOut(setTimeout(handleAllOpenChat, 500));
  //   }
  // }, [searchQuery]);

 
  const loadMoreTickets = () =>{
    if(currentPage<totalPages){
      setCurrentPage((prevPage) => prevPage + 1);
    }
}
const hasMoreTickets = currentPage < totalPages;




  return (
    <CommonTicket
      AllTicket={openTicketData}
      setAllTicketData={setOpenTicketData}
      loadMore={loadMoreTickets}
      hasMore={hasMoreTickets}
      loading={loading}
    />
  );
};

export default OpenTicket;
